import React from 'react'
import BandeiraListPageContainer from './BandeiraListPageContainer'

export class BandeiraListPage extends React.Component {
  render() {
    return <BandeiraListPageContainer {...this.props} />
  }
}
